<template>
  <v-autocomplete
    v-bind="$attrs"
    :value="value"
    :items="pItems"
    item-value="id"
    item-title="name"
    clearable
    cache-items
    chips
    color="primary"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #append>
      <v-tooltip location="bottom">
        <template #activator="{ props }">
          <v-icon
            class="selector-default-help-icon"
            color="grey"
            size="18"
            v-bind="props"
          >
            mdi-help
          </v-icon>
        </template>
        <span>{{ helpText }}</span>
      </v-tooltip>
    </template>
  </v-autocomplete>
</template>
  
  
  <script>
import { AudienceAPIInstance } from "../../../../api";

export default {
  props: {
    value: {},
    data: {
      type: Array,
      default: () => [],
    },
    helpText: {
      type: String,
      default: "",
    },
    timeout: {
      type: Number,
      default: 400,
    },
    tooltipAttrs: {
      type: Object,
      default: () => ({
        bottom: true,
      }),
    },
    autoload: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["onSearch", "update:modelValue"],
  data() {
    return {
      api: AudienceAPIInstance,
      search: "",
      pTimeout: undefined,
      pItems: this.data,

      // Autoload
      pagination: {
        page: 1,
        pageSize: 50,
      },
    };
  },
  mounted() {
    if (this.autoload) this.getList();
  },
  methods: {
    async getList(search) {
      const { pagination, items } = await this.api.ages(this.pagination, {
        search: search ? search : this.search,
      });

      this.pagination = pagination;
      this.pItems = items;
    },
    remove(item) {
      const index = this.friends.indexOf(item.name);
      if (index >= 0) this.friends.splice(index, 1);
    },
  },
  watch: {
    search(newVal) {
      if (this.pTimeout) clearTimeout(this.pTimeout);

      this.pTimeout = setTimeout(() => {
        if (this.autoload) this.getList(newVal);
        this.$emit("onSearch", newVal);
      }, this.timeout);
    },
  },
};
</script>
  
  
  <style lang="scss" scoped>
.v-input__control {
  div {
    background: transparent !important;
  }
}
.v-input__slot {
  background: transparent;
}

.selection {
  margin-top: 4px;
  margin-left: 4px;
  color: black;
}
</style>